import IServerOperation from './interface/IServerOperation'

/**
 * 相交
 */
export default class Intersect extends IServerOperation {
    constructor(serviceUrl, proxyUrl) {
        super('intersection', serviceUrl, proxyUrl)
    }
}
